export default __webpack_public_path__ + "static/media/2.3777c9ab.png";